import moment from 'moment';

export const formatDate = (date: string) => {
  const data = moment(date).utc().format('DD/MM/YYYY');
  return data ?? "-";
};
